import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import arrow from '@/components/misc/arrow'
import requisitesCard from '@/components/services/sendernames/form/requisites/card'

function renderHeader(h, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header'
    },
    [
      this.getTranslate(`${Services.requisites}.title`),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderItem(h, item, index) {
  return h(
    requisitesCard,
    {
      props: {
        value: item
      },
      key: item.id || `sendernames-requisite-${index}`
    }
  )
}
function renderItems(h) {
  if (this.items.length) {
    return h(
      'div',
      {
        class: `${Services.sendernames}-form-requisites`
      },
      [
        this.items.map((item, index) => {
          return renderItem.call(this, h, item, index)
        })
      ]
    )
  } else {
    return h(components.empty)
  }
}

export default function(h) {
  if (!this.canGetRequisites) {
    return null
  }

  return h(
    components['expansion-panels'],
    {
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      h(
        components['expansion-panel'],
        {
          scopedSlots: {
            header: ({ expanded }) => {
              return renderHeader.call(this, h, expanded)
            },
            default: () => {
              return renderItems.call(this, h)
            }
          }
        }
      )
    ]
  )
}
